<template>
  <div>
    <div class="handsontable">
      <hot-table
        ref="hotTableComponent"
        :colWidths="colWidths"
        :width="width"
        :height="height"
        :data="tb"
        :mergeCells="mergeCells"
        :cell="cell"
        :licenseKey="licenseKey"
      ></hot-table>
    </div>
    <div style="padding-top: 10px; text-align: center">
      <el-button
        type="primary"
        size="mini"
        :loading="loading"
        @click="toDownLoad"
        >下载</el-button
      >
      <el-button type="primary" size="mini" :loading="loading" @click="print"
        >打印</el-button
      >
    </div>
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
export default {
  name: "index",
  components: {
    HotTable,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    report_yidong: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      width: 1110,
      height: 800,
      tb: [],
      mergeCells: [],
      cell: [],
      licenseKey: "non-commercial-and-evaluation",
      loading: false,
      colWidths: [270, 120, 120, 120, 120, 120, 120, 120],
      zdjcqycwb: {
        id: "",
        code: "",
        name: "",
        date_range: "",
        duty_person: "",
        count_person: "",
        insert_person: "",
        phone: "",
        insert_date: "",
        doc_id: "",
        month_query: "",
        year_query: "",
        quarter_query: "",
        unit: "",
      },
      tb_zdjcqycwb0List: [],
      fileList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      self.loading = true;
      //修改提交
      self.$axios
        .get("/business/data-insert/zdjcqycwb", {
          params: {
            id: self.id,
          },
        })
        .then((res) => {
          self.zdjcqycwb = res.data.zdjcqycwb;
          self.tb_zdjcqycwb0List = res.data.tb_zdjcqycwb0List;
          self.initOption(res.data.zdjcqycwb, res.data.tb_zdjcqycwb0List);
          self.loading = false;
        })
        .catch((err) => {
          console.log("error", err);
          self.loading = false;
        });
    },
    initOption(zdjcqycwb, tb_zdjcqycwb0List) {
      const self = this;
      self.tb = [];
      const row1 = ["重点监测企业财务表", "", "", "", "", "", "", ""];
      const row2 = ["组织机构代码", zdjcqycwb.code, "", "", "", "", "", ""];
      const row3 = [
        "单位详细名称",
        zdjcqycwb.name,
        "",
        "",
        "",
        "",
        "计量单位：",
        zdjcqycwb.unit,
      ];
      const row4 = ["指标名称", "代码", "本月", "上年同月", "", "", "", ""];
      self.tb.push(row1);
      self.tb.push(row2);
      self.tb.push(row3);
      self.tb.push(row4);
      tb_zdjcqycwb0List.forEach((tb_zdjcqycwb0) => {
        const temp = [
          tb_zdjcqycwb0.name,
          tb_zdjcqycwb0.code,
          tb_zdjcqycwb0.this_month,
          tb_zdjcqycwb0.last_year_month,
          "",
          "",
          "",
          "",
        ];
        self.tb.push(temp);
      });
      const row37 = [
        "单位负责人:",
        zdjcqycwb.duty_person,
        "统计负责人:",
        zdjcqycwb.count_person,
        "填表人:",
        zdjcqycwb.insert_person,
        "联系电话:",
        zdjcqycwb.phone,
      ];
      const row38 = [
        "报出日期:",
        zdjcqycwb.insert_date,
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      self.tb.push(row37);
      self.tb.push(row38);

      self.initMergeCells();
      self.initcell();
    },
    initMergeCells() {
      const self = this;
      self.mergeCells = [];
      let row0 = { row: 0, col: 0, rowspan: 1, colspan: 8 };
      let row1 = { row: 1, col: 1, rowspan: 1, colspan: 7 };
      let row2 = { row: 2, col: 1, rowspan: 1, colspan: 5 };
      self.mergeCells.push(row0);
      self.mergeCells.push(row1);
      self.mergeCells.push(row2);
      for (let i = 3; i < 36; i++) {
        const temp = { row: i, col: 3, rowspan: 1, colspan: 5 };
        self.mergeCells.push(temp);
      }

      let row37 = { row: 37, col: 1, rowspan: 1, colspan: 7 };
      self.mergeCells.push(row37);
    },
    initcell() {
      const self = this;
      self.cell = [];
      self.cell.push({
        row: 0,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 1,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 2,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 2,
        col: 1,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 2,
        col: 6,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 2,
        col: 7,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 3,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 3,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 3,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 3,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      for (let i = 4; i < 36; i++) {
        self.cell.push({
          row: i,
          col: 0,
          className: "htCenter htMiddle",
          readOnly: true,
        });
        self.cell.push({
          row: i,
          col: 1,
          className: "htCenter htMiddle",
          readOnly: true,
        });
        if (i == 10) {
          //资产总计
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorZczjThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            validator: self.validatorZczjLast,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 11) {
          //负债合计
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorFzhjThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 13) {
          //营业收入
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorYysrThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            validator: self.validatorYysrLast,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 28) {
          //营业利润
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorYylrThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 32) {
          //利润总额
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorLrzeThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 21) {
          //其中税金
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorQzsjThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            validator: self.validatorQzsjLast,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else {
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        }
      }

      self.cell.push({
        row: 36,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 36,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 36,
        col: 4,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 36,
        col: 6,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 37,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 37,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
    },
    toDownLoad() {
      window.open(
        window.location.origin +
          "/api/business/data-insert/zdjcqycwb/download?id=" +
          this.id
      );
    },
    print() {
      const self = this;
      self.loading = true;
      self.$axios
        .get("/business/data-insert/zdjcqycwb/print", {
          params: {
            id: self.id,
          },
        })
        .then((res) => {
          var printWin = window.open("打印窗口", "_blank");
          printWin.document.write(res.msg);
          printWin.document.close();
          printWin.print();
          printWin.close();
          self.loading = false;
          console.log(res);
        })
        .catch((err) => {
          console.log("error", err);
          self.loading = false;
        });
    },
    validatorZczjThis(value, callback) {
      //资产总计本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const zczjThis = value;
      const zczjLast = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        10,
        3
      ); //资产总计上年同月;
      const fzhjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        11,
        2
      ); //负债合计本月
      const message = "您所填的负债合计大于资产总计!";
      const message1 = "您所填的资产总计：本月值高于去年同期50%!";
      setTimeout(function () {
        if (fzhjThis > zczjThis) {
          self.$message.warning(message);
          callback(false);
        } else if (zczjThis > zczjLast * 1.5) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorFzhjThis(value, callback) {
      //负债合合计本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const fzhjThis = value;
      const zczjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        10,
        2
      ); //资产总计本月
      const message = "您所填的负债合计大于资产总计!";
      setTimeout(function () {
        if (fzhjThis > zczjThis) {
          //启动
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorYysrThis(value, callback) {
      //营业收入本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const yysrThis = value;
      const yysrLast = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        13,
        3
      ); //营业收入去年同月;
      const yylrThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        28,
        2
      ); //营业利润本月
      const message = "您所填的营业利润大于营业收入!";
      const message1 = "您所填的营业收入：本月值高于去年同期50%!";
      setTimeout(function () {
        if (yylrThis > yysrThis) {
          self.$message.warning(message);
          callback(false);
        } else if (yysrThis > yysrLast * 1.5) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorYylrThis(value, callback) {
      //营业利润本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const yylrThis = value;
      const yysrThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        13,
        2
      ); //营业收入本月
      const message = "您所填的营业利润大于营业收入!";
      setTimeout(function () {
        if (yylrThis > yysrThis) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorLrzeThis(value, callback) {
      //利润总额本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const lrzeThis = value;
      const qzsjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        21,
        2
      ); //其中：税金本月
      const message = "您所填的税金大于利润总额!";
      setTimeout(function () {
        if (qzsjThis > lrzeThis) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorQzsjThis(value, callback) {
      //其中税金
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const qzsjThis = value;
      const qzsjLast = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        21,
        3
      ); //其中：税金去年本月;
      const lrzeThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        32,
        2
      ); //利润总额
      const message = "您所填的税金大于利润总额!";
      const message1 = "您所填的税金：本月值高于去年同期50%!";
      setTimeout(function () {
        if (qzsjThis > lrzeThis) {
          self.$message.warning(message);
          callback(false);
        } else if (qzsjThis > qzsjLast * 1.5) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorZczjLast(value, callback) {
      //资产总计上年同月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const zczjLast = value; //资产总计上年同月;
      const zczjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        10,
        2
      ); //资产总计本月
      const message = "您所填的资产总计：本月值高于去年同期50%!";
      setTimeout(function () {
        if (zczjThis > zczjLast * 1.5) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorYysrLast(value, callback) {
      //营业收入上年同月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const yysrLast = value;
      const yysrThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        13,
        2
      ); //营业收入本月
      const message = "您所填的营业收入：本月值高于去年同期50%!";
      setTimeout(function () {
        if (yysrThis > yysrLast * 1.5) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorQzsjLast(value, callback) {
      //其中税金去年同月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const qzsjLast = value;
      const qzsjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        21,
        2
      ); //其中：税金去月;
      const message = "您所填的税金：本月值高于去年同期50%!";
      setTimeout(function () {
        if (qzsjThis > qzsjLast * 1.5) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
  },
};
</script>
<style>
.wtHider {
  margin: auto;
}
</style>